import axios from 'axios';
import ScheduleFilter from './schedule-filter.entity';
import EmployeeSchedulePage from './employee-schedule-page.entity';
import AuditHomeTime from '../activitie/audit-home-time.entity';

export default class EmployeeScheduleService {
  static get(pagination: any, filter: ScheduleFilter):Promise<EmployeeSchedulePage> {
    return axios
      .post(`/api/employees/schedules?page=${pagination.page - 1}&size=${pagination.itemsPerPage}`, filter)
      .then((response: any) => EmployeeSchedulePage.of(response.data));
  }

  public static async getHomeTimeActivities(expectedDate: string): Promise<AuditHomeTime[]> {
    return axios.get(`/api/employees/schedule/home-time-activity-audit?expectedDate=${expectedDate}`)
      .then(({ data }) => data.map((item: any) => new AuditHomeTime(item)));
  }
}
